import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const stats = [{
  value: 68,
  suffix: '%',
  label: 'Increase in Lead Generation',
  subtext: 'Enhanced design and SEO strategies have led to a substantial rise in inquiries.'
}, {
  value: 30,
  suffix: '%',
  label: 'Reduction in Bounce Rates',
  subtext: 'Improved user experience keeps visitors engaged longer.'
}, {
  value: 25,
  suffix: '%',
  label: 'Increase in Sales Conversion',
  subtext: 'Streamlined navigation and clear calls-to-action guide users toward making a purchase.'
}];
function Counter({
  from,
  to,
  duration = 2
}: {
  from: number;
  to: number;
  duration?: number;
}) {
  const [count, setCount] = useState(from);
  const nodeRef = useRef(null);
  const isInView = useInView(nodeRef, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (!isInView) return;
    let startTime: number;
    let animationFrame: number;
    const updateCount = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / (duration * 1000), 1);
      setCount(Math.floor(progress * (to - from) + from));
      if (progress < 1) {
        animationFrame = requestAnimationFrame(updateCount);
      }
    };
    animationFrame = requestAnimationFrame(updateCount);
    return () => cancelAnimationFrame(animationFrame);
  }, [isInView, from, to, duration]);
  return <span ref={nodeRef} data-id="element-107">{count}</span>;
}
export function StatsSection() {
  return <section className="py-20 bg-gray-50" data-id="element-108">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <div className="text-center mb-16" data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A2540] mb-4" data-id="element-111">
            Proven Results
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-112">
            We don't just build pretty websites. We build revenue-generating
            assets for dealerships.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-113">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-[#0EA5E9] hover:shadow-xl transition-shadow" data-id="element-114">
              <div className="flex items-baseline justify-center mb-4 text-[#0A2540]" data-id="element-115">
                <span className="text-6xl font-bold" data-id="element-116">
                  <Counter from={0} to={stat.value} data-id="element-117" />
                </span>
                <span className="text-4xl font-bold text-[#0EA5E9]" data-id="element-118">
                  {stat.suffix}
                </span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3" data-id="element-119">
                {stat.label}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed" data-id="element-120">
                {stat.subtext}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}